import { Empty, Spin, Typography } from 'antd';
import React from 'react';
import { CardChangeButton } from '../../../../../components/Card';
import { texts } from '../../../constants/texts';
import AddInfoBlock from '../AddInfoBlock/AddInfoBlock';
import InfoCard from '../../common/InfoCard/InfoCard';
import styles from './CommentCard.module.scss';

const { Paragraph } = Typography;

const CommentCard = ({
  className,
  comment = '',
  loading = false,
  dark = true,
  onChangeBtnClick,
}) => {
  const addInfoBlock =
    typeof onChangeBtnClick === 'function' ? (
      <AddInfoBlock
        text={texts.addComment}
        onAddBtnClick={onChangeBtnClick}
      />
    ) : null;

  return (
    <InfoCard
      title="Комментарий"
      className={className}
      action={
        comment &&
        typeof onChangeBtnClick === 'function' && (
          <CardChangeButton onClick={onChangeBtnClick} disabled={loading} />
        )
      }
      dark={dark}
    >
      <Spin spinning={loading}>
        {!comment ? (
          <>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            {addInfoBlock}
          </>
        ) : (
          <Typography className={styles.comment}>
            <Paragraph>{comment}</Paragraph>
          </Typography>
        )}
      </Spin>
    </InfoCard>
  );
};

export default CommentCard;
